import { Text, View } from "@react-pdf/renderer";
import styles from '../styles/styles';
import Element from "./element";

interface NatureProps {
  labels: {
    header: string;
    hnvForestAbove9: string;
    hnvAbove5: string;
    hnvValueForest: string;
    hnvValue: string;
    nbl: string;
    heathland: string;
    dispensation: string;
    natura2000: string;
    subjectToNotification: string;
    heritageSite: string;
    redlistSpecies: string;
    skl25: string;
    natureValues: string;
  };
  data: {
    hnvForestAbove9: string | null | undefined;
    hnvAbove5: string | null | undefined;
    hnvValue: string | null | undefined;
    nbl: string | null | undefined;
    heathland: string | null | undefined;
    dispensation: string | null | undefined;
    natura2000: string | null | undefined;
    subjectToNotification: string | null | undefined;
    heritageSite: string | null | undefined;
    redlistSpecies: string | null | undefined;
    skl25: string | null | undefined;
    natureValues: string | null | undefined;
  };
}

const Nature = ({ labels, data }: NatureProps) => (
  <>
    <View style={styles.row}>
      <Text style={styles.subHeader}>{labels.header}</Text>
    </View>

    {data.hnvForestAbove9 !== undefined && <>
      <View style={styles.miniSpacer} />

      <View style={styles.row}>
        <Element label={labels.hnvForestAbove9} data={data.hnvForestAbove9} />
        {data.hnvValue !== undefined && <Element label={labels.hnvValue} data={data.hnvValue} />}

        {data.hnvValue === undefined && <View style={styles.column} />}
        <View style={styles.column} />
        <View style={styles.column} />
      </View>
    </>}

    {data.hnvAbove5 !== undefined && <>
      <View style={styles.miniSpacer} />

      <View style={styles.row}>
        <Element label={labels.hnvAbove5} data={data.hnvAbove5} />
        {data.hnvValue !== undefined && <Element label={labels.hnvValue} data={data.hnvValue} />}

        {data.hnvValue === undefined && <View style={styles.column} />}
        <View style={styles.column} />
        <View style={styles.column} />
      </View>
    </>}

    {data.nbl !== undefined && <>
      <View style={styles.miniSpacer} />

      <View style={styles.row}>
        <Element label={labels.nbl} data={data.nbl} />
        {data.heathland !== undefined && <Element label={labels.heathland} data={data.heathland} />}
        {data.dispensation !== undefined && <Element label={labels.dispensation} data={data.dispensation} />}

        {data.heathland === undefined && <View style={styles.column} />}
        {data.dispensation === undefined && <View style={styles.column} />}
        <View style={styles.column} />
      </View>
    </>}

    {data.natura2000 !== undefined && <>
      <View style={styles.miniSpacer} />

      <View style={styles.row}>
        <Element label={labels.natura2000} data={data.natura2000} />
        {data.subjectToNotification !== undefined && <Element label={labels.subjectToNotification} data={data.subjectToNotification} />}

        {data.subjectToNotification === undefined && <View style={styles.column} />}
        <View style={styles.column} />
        <View style={styles.column} />
      </View>
    </>}

    {data.heritageSite !== undefined && <>
      <View style={styles.miniSpacer} />

      <View style={styles.row}>
        <Element label={labels.heritageSite} data={data.heritageSite} />
      </View>
    </>}

    {data.redlistSpecies !== undefined && <>
      <View style={styles.miniSpacer} />

      <View style={styles.row}>
        <Element label={labels.redlistSpecies} data={data.redlistSpecies} />
      </View>
    </>}

    {data.skl25 !== undefined && <>
      <View style={styles.miniSpacer} />

      <View style={styles.row}>
        <Element label={labels.skl25} data={data.skl25} />
      </View>
    </>}

    {data.natureValues !== undefined && <>
      <View style={styles.miniSpacer} />

      <View style={styles.row}>
        <Element label={labels.natureValues} data={data.natureValues} />
      </View>
    </>}
  </>
);

export default Nature;